<div style="flex: 1 0 auto">
  <cp-banner></cp-banner>
  <div class="sticky">
    <cp-toolbar [setupInfo]="setupInfo"></cp-toolbar>
  </div>
  <cp-account-info></cp-account-info>
  <!--This is to avoid reload during acquireTokenSilent() because of hidden iframe -->
  @if (!isIframe) {
    <router-outlet></router-outlet>
  }
</div>
<div style="flex-shrink: 0">
  <cp-footer></cp-footer>
</div>
